import { notifyManager } from '../core';
import { unstable_batchedUpdates } from './reactBatchedUpdates';
notifyManager.setBatchNotifyFunction(unstable_batchedUpdates);


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-query/es/react/setBatchUpdatesFn.js
// module id = 1671
// module chunks = 29